const stores = {
  USER_STORE: "user",
  THEME_STORE: "themeStore",
  CHATS_STORE: "chats",
}

export default stores
